import React from "react";
import ReactApexChart from "react-apexcharts";
import SaveBtn from "../../../common/SaveBtn";
import colors from "../../../../helpers/colors";
import useRDVPies from "./useRDVPies";

const RDVPies = ({
  url,
  year,
  displayTotal,
  showLine = true,
  showPie = true,
  otherPostParams = {},
}) => {
  const { isLoading, chartState, getDatas, hasDatas, total1, total2 } = useRDVPies(
    url,
    year,
    otherPostParams
  );

  return (
    <div className="row">
      <div className="col-12 d-flex align-items-center justify-content-end">
        <SaveBtn
          type={hasDatas ? "btn-default d-center" : "btn-primary d-center"}
          color={hasDatas ? colors.primary : colors.default}
          margin="m-0 get-stat-btn"
          save={getDatas}
          isSaving={isLoading}
          text={
            hasDatas ? (
              <>
                <i className="fa fa-sync mr-2" />
                Actualiser les données
              </>
            ) : (
              <>
                <i className="fa fa-cloud-download-alt mr-2" />
                Charger les données
              </>
            )
          }
        />
      </div>
      {!isLoading && hasDatas ? (
        <>
          <div className="col-12 col-md-6">
            <h5>RDV EG</h5>
            {showLine && (
              <ReactApexChart
                options={chartState.line1.options}
                series={chartState.line1.series}
                type="bar"
                height={350}
              />
            )}
          </div>

          <div className="col-12 col-md-6">
            {showPie && (
              <ReactApexChart
                options={chartState.pie1.options}
                series={chartState.pie1.series}
                type="pie"
                height={350}
              />
            )}
          </div>
          <div className="col-12 text-center font-weight-bold ">TOTAL : {total1}</div>
          <div className="col-12 text-center font-weight-bold mb-4">
            % RDV EG Reportés : {chartState.rdvEGReported}%
          </div>
          <div className="col-12 col-md-6 ">
            <h5>RDV CAF</h5>
            {showLine && (
              <ReactApexChart
                options={chartState.line2.options}
                series={chartState.line2.series}
                type="bar"
                height={350}
              />
            )}
          </div>

          <div className="col-12 col-md-6 ">
            {showPie && (
              <ReactApexChart
                options={chartState.pie2.options}
                series={chartState.pie2.series}
                type="pie"
                height={350}
              />
            )}
          </div>
          <div className="col-12 text-center font-weight-bold">TOTAL : {total2}</div>
          <div className="col-12 text-center font-weight-bold">
            % RDV CAF Reportés : {chartState.rdvRdspReported}%
          </div>
        </>
      ) : null}
    </div>
  );
};

export default RDVPies;
